module.exports = __webpack_public_path__ + "static/turquia-009-46b291066422387babd6085d9bb2afde.jpg";